import { BUSINESS, SERVICE_AREA } from "@/lib/business";

// One global Plumber (LocalBusiness) block, injected site-wide from __root.
// Deliberately omits geo, founder, hasCredential, sameAs, and aggregateRating.
export function plumberSchema() {
  return {
    "@context": "https://schema.org",
    "@type": "Plumber",
    "@id": `${BUSINESS.url}/#business`,
    name: BUSINESS.name,
    url: `${BUSINESS.url}/`,
    telephone: `+1-${BUSINESS.phone}`,
    image: `${BUSINESS.url}/logo.png`,
    address: {
      "@type": "PostalAddress",
      streetAddress: BUSINESS.address,
      addressLocality: BUSINESS.city,
      addressRegion: BUSINESS.state,
      postalCode: BUSINESS.zip,
      addressCountry: "US",
    },
    openingHoursSpecification: [
      { "@type": "OpeningHoursSpecification", dayOfWeek: ["Monday","Tuesday","Wednesday","Thursday","Friday"], opens: "06:00", closes: "17:00" },
      { "@type": "OpeningHoursSpecification", dayOfWeek: "Saturday", opens: "06:00", closes: "14:00" },
    ],
    foundingDate: String(BUSINESS.founded),
    areaServed: SERVICE_AREA.map((c) => ({ "@type": "City", name: c })),
    priceRange: "$$",
  };
}

export function faqSchema(faqs: { q: string; a: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    mainEntity: faqs.map((f) => ({
      "@type": "Question",
      name: f.q,
      acceptedAnswer: { "@type": "Answer", text: f.a },
    })),
  };
}

export function breadcrumbSchema(items: { name: string; url: string }[]) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${BUSINESS.url}${it.url}`,
    })),
  };
}

export function serviceSchema(name: string, description: string, areaServed?: string) {
  return {
    "@context": "https://schema.org",
    "@type": "Service",
    serviceType: name,
    name,
    description,
    provider: { "@id": `${BUSINESS.url}/#business` },
    areaServed: areaServed ? { "@type": "City", name: areaServed } : SERVICE_AREA.map((c) => ({ "@type": "City", name: c })),
  };
}

export function articleSchema(post: { title: string; description: string; date: string; slug: string }) {
  return {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: post.title,
    description: post.description,
    datePublished: post.date,
    dateModified: post.date,
    author: { "@type": "Organization", name: BUSINESS.name },
    publisher: { "@type": "Organization", name: BUSINESS.name, logo: { "@type": "ImageObject", url: `${BUSINESS.url}/logo.png` } },
    mainEntityOfPage: `${BUSINESS.url}/${post.slug}`,
  };
}